export enum Languages {
  FR = "fr",
  EN = "en",
}
